import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { Props } from "./types";
import { DataTypeFilter } from "./dataTypeFilter";
import styles from "./styles.scss";

function Filters({ filter, areDataTypesDisplayed = false, setFilter }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.section}>
        <p className={styles.label}>
          {t("projectPage.listsPage.filters.seeTasksOf")} :
        </p>
        <FilterMenu
          filter={filter}
          placeholder={t("projectPage.listsPage.filters.allResources")}
          views={[
            "resources",
            "groups",
            "resourceTags",
            "projectsElementsTags",
          ]}
          openedViews={["resources"]}
          setFilter={(nextFilter) => {
            setFilter({
              ...filter,
              ...(!!nextFilter.resources && {
                resources: nextFilter.resources,
              }),
              ...(!!nextFilter.groups && { groups: nextFilter.groups }),
              ...(!!nextFilter.resourceTags && {
                resourceTags: nextFilter.resourceTags,
              }),
              ...(!!nextFilter.projectsElementsTags && {
                projectsElementsTags: nextFilter.projectsElementsTags,
              }),
            });
          }}
        />
      </div>
      {areDataTypesDisplayed && (
        <div className={styles.section}>
          <DataTypeFilter
            dataTypes={filter.elementTypes}
            select={(elementTypes) => setFilter({ ...filter, elementTypes })}
          />
        </div>
      )}
      <div>
        <button
          className={styles.resetButton}
          onClick={() =>
            setFilter({
              projects: filter.projects,
              scope: filter.scope,
              elementTypes: [
                "list",
                "task",
                "milestone",
                "event",
                "completedWork",
              ],
            })
          }
        >
          {t("projectPage.listsPage.filters.resetFilters")}
        </button>
      </div>
    </>
  );
}

export { Filters };
